module.exports = __webpack_public_path__ + "static/img/Testimonial1.27fc215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial1.png
// module id = XiGS
// module chunks = 0